<template>
    <div>
        <div class="block-content block-content-full">
            <div class="row">
                <div class="col-12 col-lg-4 pl-o ml-0">
                    <h2 class="content-heading">
                        Welcome
                        <span class="text-success">{{
                            `${user.first_name} ${user.last_name}`
                        }}</span>
                    </h2>

                    <div class="mt-n2">
                        <span
                            >Account Number:
                            <span
                                class="font-w600 h4 badge badge-success"
                                >{{ account.number }}</span
                            >
                        </span>
                        <br />
                        <span
                            >Current IP:
                            <span class="font-w600">{{ account.ip }}</span>
                        </span>
                        <br />

                        <span
                            >Current Date:
                            <span class="font-w600">{{ account.now }}</span>
                        </span>
                    </div>
                </div>
                <!-- <div id="creditcard_" class="creditcard_ col-lg-5 px-10 col-sm-12 col-md-12 pr-0">
                    <creditCard
                    id="cc"
                        :card="card"
                        class="py-10 cardStyler"
                        style="width: 65%; margin-top: 1.8rem; z-index: 1000;"
                    />
                </div> -->
            </div>
        </div>
        <div class="block-content block-content-full">
            <div class="row mt-5">
                <!-- Row #1 -->
                <div class="col-12 col-xl-3">
                    <a
                        style="border-right: 5px solid #9ccc65"
                        class="block mycard block-link-shadow text-right"
                        href="javascript:void(0)"
                    >
                        <div class="block-content block-content-full clearfix">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <!-- <i
                                    class="si si-wallet fa-3x text-body-bg-dark"
                                ></i> -->
                            </div>
                            <div
                                class="
                                    font-size-h4 font-w600
                                    js-count-to-enabled
                                "
                                data-toggle="countTo"
                                data-speed="1000"
                                data-to="1500"
                            >
                                {{ account.curr_symbol
                                }}{{
                                    parseFloat(account.balance)
                                        .toFixed(2)
                                        .replace(
                                            /(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1,"
                                        )
                                }}
                            </div>
                            <div
                                class="
                                    font-size-sm font-w600
                                    text-uppercase text-muted
                                "
                            >
                                Balance
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-xl-3">
                    <a
                        style="border-right: 5px solid #ffca28"
                        class="block block-link-shadow mycard text-right"
                        href="javascript:void(0)"
                    >
                        <div class="block-content block-content-full clearfix">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <!-- <i
                                    class="si si-wallet fa-3x text-body-bg-dark"
                                ></i> -->
                            </div>
                            <div class="font-size-h4 font-w600">
                                <span
                                    data-toggle="countTo"
                                    data-speed="1000"
                                    data-to="780"
                                    class="js-count-to-enabled"
                                >
                                    {{ account.curr_symbol
                                    }}{{
                                        parseFloat(account.checking)
                                            .toFixed(2)
                                            .replace(
                                                /(\d)(?=(\d{3})+(?!\d))/g,
                                                "$1,"
                                            )
                                    }}</span
                                >
                            </div>
                            <div
                                class="
                                    font-size-sm font-w600
                                    text-uppercase text-muted
                                "
                            >
                                Checking
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-xl-3">
                    <a
                        style="border-right: 5px solid #e8817f"
                        class="block block-link-shadow mycard text-right"
                        href="javascript:void(0)"
                    >
                        <div class="block-content block-content-full clearfix">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <!-- <i
                                    class="si si-bag fa-3x text-body-bg-dark"
                                ></i> -->
                            </div>
                            <div
                                class="
                                    font-size-h4 font-w600
                                    js-count-to-enabled
                                "
                                data-toggle="countTo"
                                data-speed="1000"
                                data-to="15"
                            >
                                {{ account.curr_symbol
                                }}{{
                                    parseFloat(account.mortgage)
                                        .toFixed(2)
                                        .replace(
                                            /(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1,"
                                        )
                                }}
                            </div>
                            <div
                                class="
                                    font-size-sm font-w600
                                    text-uppercase text-muted
                                "
                            >
                                Mortgage
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-12 col-xl-3">
                    <a
                        style="border-right: 5px solid #498abe"
                        class="block block-link-shadow mycard text-right"
                        href="javascript:void(0)"
                    >
                        <div class="block-content block-content-full clearfix">
                            <div class="float-left mt-10 d-none d-sm-block">
                                <!-- <i
                                    class="si si-credit-card fa-3x text-body-bg-dark"
                                ></i> -->
                            </div>
                            <div
                                class="
                                    font-size-h4 font-w600
                                    js-count-to-enabled
                                "
                                data-toggle="countTo"
                                data-speed="1000"
                                data-to="4252"
                            >
                                {{ account.curr_symbol
                                }}{{
                                    parseFloat(account.card)
                                        .toFixed(2)
                                        .replace(
                                            /(\d)(?=(\d{3})+(?!\d))/g,
                                            "$1,"
                                        )
                                }}
                            </div>
                            <div
                                class="
                                    font-size-sm font-w600
                                    text-uppercase text-muted
                                "
                            >
                                Card
                            </div>
                        </div>
                    </a>
                </div>
                <!-- END Row #1 -->
            </div>
        </div>

        <div class="block block-content-full">
            <div class="block-content">
                <div class="py-10 row mb-10">
                    <button
                        @click.prevent="transactionModal"
                        type="button"
                        class="btn mybtn bg-success min-width-125 mr-2"
                        data-toggle="click-ripple"
                        style="overflow: hidden; position: relative; z-index: 1;"
                    >
                        <i class="fa fa-exchange"></i>
                        Transfer
                    </button>

                    <button
                        @click.prevent="showModal"
                        type="button"
                        class="btn mybtn bg-success min-width-125"
                        data-toggle="click-ripple"
                        style="overflow: hidden; position: relative; z-index: 1;"
                    >
                        <i class="si si-credit-card"></i>
                        Card Request
                    </button>
                </div>
            </div>

            <div
                v-if="disabledMessage"
                class="alert alert-danger"
                v-html="account.disabled_message"
            ></div>

            <div class="block-header block-header-default">
                <h3 class="block-title">Recent Transactions</h3>
            </div>
            <div class="block-content">
                <div class="table-responsive">
                    <table class="table table-striped table-vcenter">
                        <thead>
                            <tr role="row">
                                <th class="text-center" tabindex="0">#</th>

                                <th
                                    style="width: 100px"
                                    class="text-capitalize"
                                >
                                    Transaction Date
                                </th>

                                <th class="text-capitalize">Receiver's name</th>
                                <th class="text-capitalize">
                                    Destination Account
                                </th>
                                <th class="text-capitalize">Amount</th>
                                <th class="text-capitalize">Status</th>
                                <th class="text-capitalize">
                                    Transaction Description
                                </th>
                                <th class="text-capitalize">Debit/Credit</th>
                                <th class="text-capitalize">
                                    Transaction Type
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(transaction,
                                index) in account.transactions"
                                :key="index"
                                :style="
                                    `border-left: ${
                                        transaction.is_credit == 0
                                            ? '3px solid #e46262;'
                                            : '3px solid #9ccc65;'
                                    }`
                                "
                            >
                                <td class="text-center sorting_1">
                                    {{ index + 1 }}
                                </td>

                                <td>
                                    {{ transaction.when }}
                                </td>

                                <td>
                                    {{ transaction.receiver_name }}
                                </td>
                                <td>
                                    {{ transaction.receiver_account }}
                                </td>

                                <td>
                                    {{ transaction.curr_symbol
                                    }}{{
                                        parseFloat(transaction.amount)
                                            .toFixed(2)
                                            .replace(
                                                /(\d)(?=(\d{3})+(?!\d))/g,
                                                "$1,"
                                            )
                                    }}
                                </td>

                                <td>
                                    <span
                                        class="text-warning"
                                        v-if="transaction.status == 0"
                                        >Pending</span
                                    >
                                    <span class="text-success" v-else
                                        >Success</span
                                    >
                                </td>
                                <td>{{ transaction.description }}</td>
                                <td>
                                    <span
                                        class="text-danger"
                                        v-if="transaction.is_credit == 0"
                                        >DEBIT</span
                                    >
                                    <span class="text-success" v-else
                                        >CREDIT</span
                                    >
                                </td>
                                <td class="text-uppercase">
                                    {{ transaction.trans_option }} Transfer
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            id="modal-transactions"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fadein"
            style="display: none"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="card-title">Create Transaction</h3>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- Beginning of the form -->
                    <form @submit.prevent="sendOTP">
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="trans_option"
                                                >Transfer Type</label
                                            >
                                            <select
                                                name="trans_option"
                                                id="trans_option"
                                                class="form-control"
                                                required
                                                v-model="trans_option"
                                            >
                                                <option disabled="" selected="">
                                                    Select Option
                                                </option>
                                                <option value="international">
                                                    International Transfer
                                                </option>
                                                <!-- <option value="domestic">
                                                    Domestic Transfer
                                                </option> -->
                                                <option value="local">
                                                    Local Transfer
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="receiver_name"
                                                >Receiver's Fullname</label
                                            >
                                            <input
                                                id="receiver_name"
                                                name="receiver_name"
                                                type="text"
                                                class="form-control"
                                                v-model="receiver_name"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="receiver_account"
                                                >Receiver's Account
                                                Number</label
                                            >
                                            <input
                                                id="receiver_account"
                                                type="text"
                                                class="form-control"
                                                autocomplete="phone"
                                                v-model="receiver_account"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="bank_name"
                                                >Bank Name</label
                                            >
                                            <input
                                                id="bank_name"
                                                type="text"
                                                class="form-control"
                                                v-model="bank_name"
                                            />
                                        </div>
                                        <div
                                            class="col-lg-6"
                                            v-if="
                                                trans_option == 'international'
                                            "
                                        >
                                            <label for="bank_address"
                                                >Bank State and Country</label
                                            >
                                            <input
                                                id="bank_name"
                                                type="text"
                                                class="form-control"
                                                v-model="bank_address"
                                            />
                                        </div>

                                        <div
                                            class="col-lg-6"
                                            v-if="
                                                trans_option != 'international'
                                            "
                                        >
                                            <label for="amount">Amount</label>
                                            <input
                                                id="amount"
                                                type="text"
                                                class="form-control"
                                                autocomplete="amount"
                                                v-model="amount"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="form-group row"
                                        v-if="trans_option == 'international'"
                                    >
                                        <div class="col-lg-6">
                                            <label for="swift"
                                                >Swift Code</label
                                            >
                                            <input
                                                id="swift"
                                                type="text"
                                                class="form-control"
                                                v-model="swift"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="trans_option"
                                                >Routing/IBAN Number</label
                                            >
                                            <input
                                                id="swift"
                                                type="text"
                                                class="form-control"
                                                v-model="iban"
                                            />
                                        </div>
                                    </div>

                                    <div
                                        class="form-group row"
                                        v-if="trans_option == 'international'"
                                    >
                                        <div class="col-lg-6">
                                            <label for="amount">Amount</label>
                                            <input
                                                id="amount"
                                                type="text"
                                                class="form-control"
                                                autocomplete="amount"
                                                v-model="amount"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-lg-12">
                                            <label for="description"
                                                >Transfer Description</label
                                            >
                                            <textarea
                                                v-model="description"
                                                name="desc"
                                                class="form-control"
                                                placeholder=""
                                            >
                                            </textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-12">
                                            <button
                                                v-if="processing"
                                                type="submit"
                                                disabled
                                                class="
                                                    btn btn-lg btn-secondary
                                                    my-btn
                                                    btn-block
                                                    mb-2
                                                "
                                            >
                                                Processing...
                                            </button>
                                            <button
                                                v-else
                                                type="submit"
                                                class="
                                                    btn
                                                    btn-lg
                                                    btn-success
                                                    btn-block
                                                    btn-rounded
                                                    mb-2
                                                "
                                            >
                                                Continue
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- card request modal -->
        <div
            class="modal fade"
            id="modal-invest"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-popin"
            style="display: none"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-popin"
                role="document"
            >
                <div class="modal-content">
                    <div class="block block-transparent mb-0">
                        <div class="block-header">
                            <h3 class="block-title">New card request</h3>
                            <div class="block-options">
                                <button
                                    type="button"
                                    class="btn-block-option"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i class="si si-close"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content">
                            <form @submit.prevent="requestCard">
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Card Type</label
                                                    >

                                                    <select
                                                        name="trans_option"
                                                        id="card_type"
                                                        class="form-control"
                                                        required
                                                        v-model="card_type"
                                                    >
                                                        <option
                                                            value="Debit Card"
                                                            selected
                                                        >
                                                            Debit Card
                                                        </option>
                                                        <option
                                                            value="Credit Card"
                                                            selected
                                                        >
                                                            Credit Card
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Card Model</label
                                                    >
                                                    <select
                                                        v-model="card_model"
                                                        name="type"
                                                        class="form-control"
                                                        required=""
                                                    >
                                                        <option value="">
                                                            Select card type
                                                        </option>
                                                        <option
                                                            value="Visa Card"
                                                        >
                                                            Visa Card
                                                        </option>
                                                        <option
                                                            value="Master Card"
                                                        >
                                                            Master Card
                                                        </option>
                                                        <option
                                                            value="American Express"
                                                        >
                                                            American Express
                                                        </option>
                                                        <option
                                                            value="Discover"
                                                        >
                                                            Discover
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div
                                                    v-if="processing"
                                                    class="col-6 col-md-3"
                                                >
                                                    <i
                                                        class="
                                                            fa
                                                            fa-2x
                                                            fa-cog
                                                            fa-spin
                                                            text-primary
                                                        "
                                                    ></i>
                                                </div>
                                                <div class="col-md-9" v-else>
                                                    <button
                                                        type="submit"
                                                        class="
                                                            btn btn-success
                                                            mb-2
                                                        "
                                                    >
                                                        Request Card
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end of card request  modal -->

        <!-- otp modal -->
        <div
            class="modal fade"
            id="modal-otp"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-popin"
            style="display: none"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-popin"
                role="document"
            >
                <div class="modal-content">
                    <div class="block block-transparent mb-0">
                        <div class="block-header">
                            <h3 class="block-title">One Time Password</h3>
                            <div class="block-options">
                                <button
                                    type="button"
                                    class="btn-block-option"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i class="si si-close"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content">
                            <form @submit.prevent="createTransaction">
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Enter your OTP</label
                                                    >

                                                    <input
                                                        class="form-control"
                                                        v-model="otp"
                                                        type="text"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <button
                                                    disabled
                                                    v-if="processing"
                                                    type="submit"
                                                    class="
                                                        btn btn-secondary
                                                        mb-2
                                                    "
                                                >
                                                    processing
                                                </button>
                                                <div class="col-md-9" v-else>
                                                    <button
                                                        type="submit"
                                                        class="
                                                            btn btn-success
                                                            mb-2
                                                        "
                                                    >
                                                        Authorize
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end of card request  modal -->
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";
import CreditCard from "../../components/Card";

const UsersRepository = RepositoryFactory.get("users");

function debounce(fn, delay) {
    var timeoutID = null;
    return function() {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function() {
            fn.apply(that, args);
        }, delay);
    };
}
export default {
    components: { CreditCard },
    data() {
        return {
            account: {},
            user: {},
            transactions: [],
            card: {},
            otp: "",
            date: "",
            amount: 0,
            description: "",
            trans_option: "international",
            receiver_name: "",
            currency: 2,
            receiver_account: "",
            is_credit: 0,
            bank_name: "",
            account: "balance",
            type: 1,
            receiver_address: "",
            bank_address: "",
            iban: "",
            processing: false,
            disabledMessage: false,
            card_model: "Visa Card",
            card_type: "Debit Card",
            swift: ""
        };
    },
    methods: {
        formatValue() {
            const newAmount = this.amount.replace(/[,]/g, "");
            if (this.amount != null && this.amount > 0) {
                this.amount = parseFloat(newAmount)
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            }
        },
        async sendOTP() {
            try {
                if (!this.validate()) return;
                if (this.user.txn_ban == "1") {
                    this.disabledMessage = true;
                    $("#modal-transactions").modal("hide");
                    return;
                }

                this.processing = true;
                await UsersRepository.sendOTP();
                this.processing = false;
                $("#modal-otp").modal("show");
                $("#modal-transactions").modal("hide");
            } catch (error) {
                this.processing = false;
                return toast.fire({
                    type: "error",
                    title: "Something went wrong. Try again"
                });
            }
        },
        userAccounts() {
            UsersRepository.loggedInUser().then(response => {
                this.user = response.data;
                UsersRepository.viewAccounts(response.data.id).then(
                    response => {
                        this.account = response.data;
                    }
                );
            });
        },
        transactionModal() {
            $("#modal-transactions").modal("show");
        },
        showModal() {
            $("#modal-invest").modal("show");
        },
        async requestCard() {
            this.processing = true;
            let data = {
                card_model: this.card_model,
                card_type: this.card_type
            };
            try {
                await UsersRepository.userCardRequest(data);
                $("#modal-invest").modal("hide");
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Card request has been sent successfully"
                });
            } catch (error) {
                this.processing = false;

                console.log(error);
            }
        },
        async loadCards() {
            try {
                let res = await UsersRepository.userFetchCards();
                this.card = res.data[0];
            } catch (error) {
                console.log(error);
            }
        },
        validate() {
            if (
                !this.receiver_account ||
                !this.receiver_name ||
                !this.description ||
                !this.bank_name ||
                !this.amount
            ) {
                toast.fire({
                    type: "error",
                    title: "Ensure all fields are filled"
                });
                return false;
            }
            if (this.trans_option == "international" && !this.bank_address) {
                toast.fire({
                    type: "error",
                    title: "Bank address and country is required"
                });
                return false;
            }

            if (this.trans_option == "international" && !this.swift) {
                toast.fire({
                    type: "error",
                    title: "Swift is required"
                });
                return false;
            }
            let balance = parseFloat(this.account.balance);

            if (this.amount > balance) {
                toast.fire({
                    type: "error",
                    title: "Balance is insufficient"
                });
                return false;
            }

            return true;
        },
        async createTransaction() {
            try {
                if (!this.validate()) return;
                if (this.user.txn_ban == "1") {
                    this.disabledMessage = true;
                    return;
                }

                this.processing = true;
                var data = {
                    is_credit: this.is_credit,
                    currency: this.currency,
                    user_id: this.user.id,
                    sender_name: `${this.user.first_name} ${this.user.last_name}`,
                    sender_account: this.user.account,
                    trans_option: this.trans_option,
                    date: this.date,
                    description: this.description,
                    receiver_name: this.receiver_name,
                    bank_name: this.bank_name,
                    bank_address: this.bank_address,
                    swift: this.swift,
                    iban: this.iban,
                    receiver_account: this.receiver_account,
                    amount: this.amount.replace(/[,]/g, "")
                };

                let info = {
                    code: this.otp
                };
                let res = await UsersRepository.verifyOTP(info);
                if (res.data.status === true) {
                    await UsersRepository.userCreateTransaction(data);
                    this.userAccounts();
                    $("#modal-transactions").modal("hide");
                    $("#modal-otp").modal("hide");
                    this.processing = false;
                    this.disabledMessage = false;
                    toast.fire({
                        type: "success",
                        title: "Transaction initiated successfully"
                    });
                } else {
                    this.processing = false;
                    this.disabledMessage = false;
                    toast.fire({
                        type: "error",
                        title: "OTP is incorrect"
                    });
                }
            } catch (error) {
                this.processing = false;
                if (error.response.status === 400) {
                    this.disabledMessage = true;
                    $("#modal-otp").modal("hide");
                } else {
                    this.disabledMessage = false;
                    toast.fire({
                        type: "error",
                        title: error.response.data.message
                    });
                }
            }
        }
    },

    created() {
        this.userAccounts();
        this.loadCards();
    },
    watch: {
        amount: debounce(function(newVal) {
            this.formatValue(newVal);
        }, 1000)
    }
};
</script>
<style scoped>
.cardStyler {
    margin-top: 4rem !important;
}
.mycard {
    border-radius: 4px;
    margin-bottom: 15px;
    border: none;
    /* background: #190b0b !important; */
    transition: all 0.4s;
    vertical-align: top;
    box-shadow: -1rem 0 3rem rgb(163, 159, 159);
}
.mt-60 {
    margin-top: 70px !important;
}
.mybtn {
    background-color: #9ccc65;
    color: white;
}
.creditcard_ {
    display: block;
}
@media only screen and (max-width: 991px) {
    #cc {
        visibility: hidden !important;
    }
}
</style>
